var t = Object.prototype.toString;
function e(e) {
  return "number" == typeof e || function (t) {
    return "object" == typeof t && null !== t;
  }(e) && "[object Number]" == function (e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : t.call(e);
  }(e);
}
var n = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"],
  r = ["mười", "hai mươi", "ba mươi", "bốn mươi", "năm mươi", "sáu mươi", "bảy mươi", "tám mươi", "chín mươi"],
  s = ["không trăm", "một trăm", "hai trăm", "ba trăm", "bốn trăm", "năm trăm", "sáu trăm", "bảy trăm", "tám trăm", "chín trăm"],
  i = function i(t) {
    var e = "".concat(t).split(""),
      s = parseInt(e[0]),
      i = parseInt(e[1]);
    return 0 === i ? r[s - 1] : 5 === i ? "".concat(r[s - 1], " l\u0103m") : 4 === i ? "".concat(r[s - 1], " t\u01B0") : 1 === i ? 1 === s ? "".concat(r[s - 1], " m\u1ED9t") : "".concat(r[s - 1], " m\u1ED1t") : "".concat(r[s - 1], " ").concat(n[i]);
  },
  $ = function $(t) {
    var e = "".concat(t).split(""),
      r = parseInt(e[0]),
      $ = parseInt(e[1]),
      o = parseInt(e[2]);
    return $ > 0 ? "".concat(s[r], " ").concat(i("".concat($).concat(o))) : 0 === o ? "".concat(s[r]) : 4 === o ? "".concat(s[r], " linh t\u01B0") : "".concat(s[r], " linh ").concat(n[o]);
  },
  o = function o(t) {
    var e = "".concat(t).split("").reverse(),
      r = e.slice(0, 3).reverse().join(""),
      s = parseInt(e.slice(3, e.length).reverse().join("")),
      o = "".concat(s).length;
    var l = "";
    return parseInt(r) >= 1 && (l = $(r)), 1 === o ? "".concat(n[s], " ngh\xECn ").concat(l) : 2 === o ? "".concat(i(s), " ngh\xECn ").concat(l) : "".concat($(s), " ngh\xECn ").concat(l);
  },
  l = function l(t) {
    var e = "".concat(t).split("").reverse(),
      r = e.slice(0, 6).reverse().join(""),
      s = parseInt(e.slice(6, e.length).reverse().join("")),
      l = "".concat(s).length;
    var c = "";
    return parseInt(r) > 999 ? c = o(r) : parseInt(r) <= 999 && parseInt(r) >= 1 && (c = $("".concat(r).split("").slice(3, 6).join(""))), 1 === l ? "".concat(n[s], " tri\u1EC7u ").concat(c) : 2 === l ? "".concat(i(s), " tri\u1EC7u ").concat(c) : "".concat($(s), " tri\u1EC7u ").concat(c);
  },
  c = function c(t) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    try {
      if (!e(t)) throw new Error("Input is not a number");
      if (Math.abs(t) > 9007199254740992) throw new Error("Your number is too big");
      if (t < 0) return "\xE2m ".concat(c(Math.abs(t)));
      var _s = "".concat(t).length;
      var _p;
      return 1 === _s && (_p = n[t]), 2 === _s && (_p = i(t)), 3 === _s && (_p = $(t)), _s > 3 && _s <= 6 && (_p = o(t)), _s > 6 && _s <= 9 && (_p = l(t)), _s > 9 && (_p = function (t) {
        var e = "".concat(t).split("").reverse(),
          r = e.slice(0, 9).reverse().join(""),
          s = parseInt(e.slice(9, e.length).reverse().join(""));
        var c = "";
        parseInt(r) > 999999 && parseInt(r) <= 999999999 ? c = l(r) : parseInt(r) <= 999999 && parseInt(r) > 999 ? c = o("".concat(r).split("").slice(3, 9).join("")) : parseInt(r) <= 999 && parseInt(r) >= 1 && (c = $("".concat(r).split("").slice(6, 9).join("")));
        var p = "".concat(s).length;
        return 1 === p ? "".concat(n[s], " t\u1EF7 ").concat(c) : 2 === p ? "".concat(i(s), " t\u1EF7 ").concat(c) : 3 === p ? "".concat($(s), " t\u1EF7 ").concat(c) : p > 3 && p <= 6 ? "".concat(o(s), " t\u1EF7 ").concat(c) : p > 6 && p <= 9 ? "".concat(l(s), " t\u1EF7 ").concat(c) : void 0;
      }(t)), r ? function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var n = t.split(" ").reverse();
        var r = n.findIndex(function (t) {
            return "trăm" === t;
          }),
          s = n.findIndex(function (t) {
            return "nghìn" === t;
          }),
          i = n.findIndex(function (t) {
            return "triệu" === t;
          }),
          $ = n.findIndex(function (t) {
            return "tỷ" === t;
          });
        return -1 !== $ && e && n.splice($, 1, "".concat(n[$]).concat(e)), -1 !== i && e && n.splice(i, 1, "".concat(n[i]).concat(e)), -1 !== s && e && -1 !== r && n.splice(s, 1, "".concat(n[s]).concat(e)), n.reverse().join(" ");
      }(_p, r) : _p;
    } catch (t) {
      console.error("error", t);
    }
  };
var p = {
  getText: c
};
export default p;
export { c as getText };